import ResultTables from "./components/table_results/ResultTables";

export const tabsOptions = (surveyType = 'Encuesta') => [{
  eventKey: 'graph',
  title: 'Gráficos',
  content: <div></div>,
  disabled: true
},{
  eventKey: 'tables',
  title: 'Tablas',
  content: <ResultTables surveyType={surveyType} />,
  disabled: false
}];